"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTriggeredInside = void 0;

/**
 * @desc
 * Checks if the event was triggered inside of the component.
 *
 * @param node
 * @param event
 * return Bool
 */
var isTriggeredInside = function isTriggeredInside(node, event) {
  return node && node.contains(event.target);
};

exports.isTriggeredInside = isTriggeredInside;
//# sourceMappingURL=is-triggered-inside.js.map